
export const maxDeposit = 7500;
export const minimumPrice = 39.00;

const NEW_PRICE_MULTIPLIER = 4.3;

// Export the priceRate constant
export const priceRate = NEW_PRICE_MULTIPLIER;